<template>
    <div>
        <div class="form-group">
            <label>
                Etichetta
            </label>
            <input type="text" v-model="localValue.sectionName" class="form-control" />
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        Nome property onOffice (autocomplete search)
                    </label>
                    <autocomplete v-model="localValue.onOfficePropertyName" :searchCallback="searchCb" :resultCallback="resultCb" :printCallback="printCb"
                        :fields="fields" @update:modelValue="setType">
                        <template #list-item="{ item }">
                            {{printCb(item)}}
                        </template>
                    </autocomplete>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        Nome property onOffice (free text input, for property not found by autocomplete)
                    </label>
                    <input class="form-control" type="text" v-model="localValue.onOfficePropertyName" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>
                Tipo di dato
            </label>
            <select class="form-control" v-model="localValue.dataType">
                <option v-for="(item, i) in dataTypes" :key="i" :value="item">
                    {{item}}
                </option>
            </select>
        </div>
        <gerita-list :list="localValue.gerItas"></gerita-list>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';
import * as CONST from '@/const';

@Options({})
export default class sectionReadConfig extends mixins(WithModel) {

    @Prop() fields: OM.GetFieldsResponseForList[];

    declare localValue: OM.SectionReadConfig;

    dataTypes = CONST.DataTypes.GetAll();

    searchCb(input: string){
        if(!input){
            return this.fields;
        }
        return this.fields.filter(x => 
            x.fieldName.toLowerCase().indexOf(input.toLowerCase()) > -1
        );
    }
    printCb(item: OM.GetFieldsResponseForList){
        if(!item)
            return "";

        return item.fieldName;
    }
    resultCb(item: OM.GetFieldsResponseForList){
        if(!item)
            return "";

        return item.fieldName;
    }
    
    setType(){
        if(this.localValue.onOfficePropertyName){
            let field = this.fields.find(x => x.fieldName == this.localValue.onOfficePropertyName);
            if(field){
                this.localValue.dataType = field.type;
            }
        }
    }

}

</script>

<style scoped>

    .accordion .accordionTitle {
        background: whitesmoke;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        align-items: center;
        cursor: pointer;
    }

    .accordion .accordionButton button {
        background: none;
        border: none;
        width: 33px;
        height: 33px;
    }

    .accordion .accordionBody {
    }

    .accordion .accordionBody.indent {
        padding-left: 20px;
    }

</style>
